import { render, staticRenderFns } from "./ProductTableComponent.vue?vue&type=template&id=64a3c51e&"
import script from "./ProductTableComponent.vue?vue&type=script&lang=js&"
export * from "./ProductTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports